<template>
  <div class="p-2 rounded bg-gray-100" v-if="i18n !== undefined">
    <h2
      class="font-bold pb-2 text-center"
      v-text="i18n.update_billing_contact"
    ></h2>
    <form @submit.prevent="validateUpdate">
      <div class="flex">
        <div class="pr-1 flex-1">
          <simple-input
            :label="i18n.form.firstname"
            v-model="form.firstname"
            name="firstname"
            :required="true"
            class="h-16"
          ></simple-input>

          <simple-input
            :label="i18n.form.lastname"
            v-model="form.lastname"
            name="lastname"
            :required="true"
            class="h-16"
          ></simple-input>

          <simple-select
            :label="i18n.form.user_activity"
            v-model="form.user_activity"
            name="user_activity"
            :required="true"
            :options="userActivities"
            class="h-16"
          ></simple-select>

          <simple-radio
            :label="i18n.form.invoice_to"
            v-model="form.invoice_to"
            name="invoice_to"
            :initial-value="form.invoice_to"
            :required="true"
            class="h-16"
            :options="[
              {
                id: '0',
                label: i18n.form.invoice_to_radio.individual,
              },
              {
                id: '1',
                label: i18n.form.invoice_to_radio.company,
              },
            ]"
          ></simple-radio>

          <simple-input
            :label="i18n.form.company"
            v-model="form.company"
            name="company"
            :required="true"
            v-if="form.invoice_to == 1"
            class="h-16"
          ></simple-input>
        </div>
        <div class="pl-1 flex-1">
          <simple-input
            :label="i18n.form.address.street"
            v-model="form.add_main"
            name="street"
            :required="true"
            class="h-16"
          ></simple-input>

          <simple-input
            :label="i18n.form.address.zipcode"
            v-model="form.add_zip"
            name="zipcode"
            :required="true"
            class="h-16"
          ></simple-input>

          <simple-input
            :label="i18n.form.address.city"
            v-model="form.add_city"
            name="city"
            :required="true"
            class="h-16"
          ></simple-input>

          <simple-input
            :label="i18n.form.address.state"
            v-model="form.add_state"
            name="state"
            class="h-16"
          ></simple-input>

          <simple-select
            :label="i18n.form.address.country"
            v-model="form.country_id"
            name="country_id"
            :required="true"
            :options="countries"
            class="h-16"
          ></simple-select>
        </div>
      </div>

      <simple-input
        :label="i18n.form.vat.label"
        :placeholder="i18n.form.vat.placeholder"
        :labelInfo="i18n.form.vat.info"
        v-model="form.vat"
        name="vat"
        v-if="form.invoice_to == 1"
        class="h-16"
      ></simple-input>

      <simple-checkbox
        :label="i18n.form.remember"
        v-model="form.remember"
        name="remember"
      ></simple-checkbox>

      <div class="flex justify-between items-center pt-1">
        <ranch-button
          :label="i18n.form.cancel"
          @click="cancelUpdate"
          action="action-secondary"
          icon="arrow-left"
        ></ranch-button>
        <ranch-button
          type="submit"
          :label="i18n.form.validate"
          icon="save"
        ></ranch-button>
      </div>
    </form>
  </div>
</template>

<script>
import { handleAxiosError, flash } from "@/boot/functions";

import { Form } from "../../Utilities/Form";
import SimpleInput from "../../Design/Forms/SimpleInput";
import SimpleSelect from "../../Design/Forms/SimpleSelect";
import SimpleRadio from "../../Design/Forms/SimpleRadio";
import SimpleCheckbox from "../../Design/Forms/SimpleCheckbox";

export default {
  props: ["account"],
  components: { SimpleInput, SimpleSelect, SimpleRadio, SimpleCheckbox },
  data() {
    const data = { remember: false, ...this.account };
    data.remember = !data.add_main;
    return {
      form: new Form(data),
    };
  },
  watch: {
    ["form.vat"](v) {
      this.form.vat = this.normalizedVatNumber(v);
    },
  },
  methods: {
    normalizedVatNumber(v) {
      return v.toUpperCase().replace(/[^A-Za-z0-9]/g, "");
    },
    validateUpdate() {
      let formToSend = { ...this.form };
      // If individual, we drop vat and company name from invoice
      if (this.form.invoice_to == 0) {
        delete formToSend.vat;
        delete formToSend.company;
      } else {
        formToSend.vat = this.normalizedVatNumber(formToSend.vat);
      }

      this.form
        .post("/api/app/billing/settings", formToSend)
        .then((data) => {
          if (this.form.remember) {
            this.$store.commit("account/setUsername", data.firstname);
            this.$store.commit("account/updateContact", data);

            this.form.remember = false;
            this.$emit("settings-saved");
            flash(this.i18n.settings_saved, "success");
          }

          this.$store.commit("account/setUserActivity", data.user_activity);
          this.$emit("settings-updated", data);
        })
        .catch(handleAxiosError);
    },
    cancelUpdate() {
      this.form.reset();
      this.$emit("cancel");
    },
  },
  computed: {
    i18n() {
      if (this.$store.state.safe.i18n !== undefined) {
        return this.$store.state.safe.i18n.new_refill.billing;
      }

      return undefined;
    },
    userActivities() {
      if (this.$store.state.formsData.userActivities !== undefined) {
        return this.$store.state.formsData.userActivities;
      }

      return [];
    },
    countries() {
      if (this.$store.state.formsData.countries !== undefined) {
        return this.$store.state.formsData.countries;
      }

      return [];
    },
  },
};
</script>
